<template>
    <div>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="活动名字" prop="active_name">
                        <el-input v-model="form.active_name"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="8">
                    <el-form-item label="活动id" prop="active_id">
                        <el-input v-model="form.active_id"></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :span="8">
                    <el-form-item label="活动" prop="active_type">
                        <el-select v-model="form.active_type" placeholder="请选择活动">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of rule_list" :key="item.active_type" :label="item.schema_name_title" :value="item.active_type"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="活动状态" prop="status">
                        <el-select v-model="form.status" placeholder="请选择活动状态">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of status" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="时间周期" prop="timetype">
                        <el-select v-model="form.timetype" placeholder="请选择时间周期">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of times" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <h3>
            <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        </h3>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="active_name" label="活动名字" fixed="left"></el-table-column>
            <el-table-column prop="timetype" label="类型" align="center">
                <template slot-scope="scope">
                    {{ show_schema_name[scope.row.schema_name] }}
                </template>
            </el-table-column>
            <el-table-column prop="amount" label="达标数量" align="center"></el-table-column>
            <el-table-column prop="point" label="奖励积分" align="center"></el-table-column>
            <el-table-column prop="sort" label="排序号" align="center"></el-table-column>
            <el-table-column prop="timetype" label="活动时间类型" align="center">
                <template slot-scope="scope">
                    {{ scope.row && scope.row.startdate ? '指定时间' : scope.row.timetype ? timetype[scope.row.timetype] : '历史' }}
                </template>
            </el-table-column>
            <el-table-column prop="startdate" label="开始时间(UTC)" align="center">
                <template slot-scope="scope">
                    {{ scope.row && scope.row.startdate ? $moment(new Date(scope.row.startdate).getTime()).utc().format('YYYY-MM-DD') : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="enddate" label="结束时间(UTC)" align="center">
                <template slot-scope="scope">
                    {{ scope.row && scope.row.enddate ? $moment(new Date(scope.row.enddate).getTime()).utc().format('YYYY-MM-DD') : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">
                    {{ scope.row.status === 1 ? '开启' : '暂停' }}
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" width="130" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <add-modal :dialogVisible="addFlag" :info="info" :rule_list="rule_list" @closeModal="closeAddModal" v-if="addFlag" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import AddModal from './add/index.vue';
export default {
    components: {
        AddModal,
    },
    data() {
        return {
            times: [
                { label: '每天', value: 'dayly' },
                { label: '每周', value: 'weekly' },
                { label: '每月', value: 'monthly' },
                { label: '固定时间段内', value: 'fixed' },
            ],
            status: [
                { label: '进行中', value: 1 },
                { label: '暂停', value: 0 },
                { label: '未开始', value: 2 },
                { label: '已结束', value: 3 },
            ],
            timetype: {
                dayly: '每天',
                weekly: '每周',
                monthly: '每月',
            },
            form: {
                active_name: '',
                active_id: '',
                active_type: '',
                type: '',
                timetype: '',
                status: '',
            },
            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,

            // rule
            rule_schema_name: {
                upvote_productHunt_no_time: 'Upvote on ProductHunt(历史)',

                submit_gpts_time_range: '提交GPTS(固定时间内)',
                submit_gpts_time_epoch: '提交GPTS(周期)',
                submit_gpts_no_time: '提交GPTS(历史)',

                upvote_gpts_time_range: 'upvote GPTS(固定时间内)',
                upvote_gpts_time_epoch: 'upvote GPTS(周期)',
                upvote_gpts_no_time: 'upvote GPTS(历史)',

                create_visual_time_range: '创建文生图prompt(固定时间内)',
                create_visual_time_epoch: '创建文生图prompt(周期)',
                create_visual_no_time: '创建文生图prompt(历史)',

                make_images_time_range: '生成图片(固定时间内)',
                make_images_time_epoch: '生成图片(周期)',
                make_images_no_time: '生成图片(历史)',

                optimize_prompt_time_range: '优化prompt(固定时间内)',
                optimize_prompt_time_epoch: '优化prompt(周期)',
                optimize_prompt_no_time: '优化prompt(历史)',
                save_prompt_time_epoch: '收藏prompt(周期)',
                save_prompt_time_range: '收藏prompt(固定时间内)',
                save_prompt_no_time: '收藏prompt(历史)',
                share_prompt_time_epoch: '分享prompt(周期)',
                share_prompt_time_range: '分享prompt(固定时间内)',
                share_prompt_no_time: '分享prompt(历史)',
                like_prompt_time_epoch: 'like prompt(周期)',
                like_prompt_time_range: 'like prompt(固定时间内)',
                like_prompt_no_time: 'like prompt(历史)',
                create_prompt_time_epoch: '创建prompt(周期)',
                create_prompt_time_range: '创建prompt(固定时间内)',
                create_prompt_no_time: '创建prompt(历史)',
                follow_user_time_epoch: 'follow user(周期)',
                follow_user_time_range: 'follow user(固定时间内)',
                follow_user_no_time: 'follow user(历史)',
                follow_thirdapp: 'follow 社交平台',
            },
            show_schema_name: {
                upvote_productHunt_no_time: 'Upvote on ProductHunt',

                submit_gpts_time_range: '提交GPTS',
                submit_gpts_time_epoch: '提交GPTS',
                submit_gpts_no_time: '提交GPTS',

                upvote_gpts_time_range: 'upvote GPTS',
                upvote_gpts_time_epoch: 'upvote GPTS',
                upvote_gpts_no_time: 'upvote GPTS',

                create_visual_time_range: '创建文生图prompt',
                create_visual_time_epoch: '创建文生图prompt',
                create_visual_no_time: '创建文生图prompt',

                make_images_time_range: '生成图片',
                make_images_time_epoch: '生成图片',
                make_images_no_time: '生成图片',

                optimize_prompt_time_epoch: '优化prompt',
                optimize_prompt_time_range: '优化prompt',
                optimize_prompt_no_time: '优化prompt',
                save_prompt_time_epoch: '收藏prompt',
                save_prompt_time_range: '收藏prompt',
                save_prompt_no_time: '收藏prompt',
                share_prompt_time_epoch: '分享prompt',
                share_prompt_time_range: '分享prompt',
                share_prompt_no_time: '分享prompt',
                like_prompt_time_epoch: 'like prompt',
                like_prompt_time_range: 'like prompt',
                like_prompt_no_time: 'like prompt',
                create_prompt_time_epoch: '创建prompt',
                create_prompt_time_range: '创建prompt',
                create_prompt_no_time: '创建prompt',
                follow_user_time_epoch: 'follow user',
                follow_user_time_range: 'follow user',
                follow_user_no_time: 'follow user',
                follow_thirdapp: 'follow 社交平台',
            },
            info: {},
            rule_list: [],
            addFlag: false,
        };
    },
    created() {
        this.getActiveRule();
        this.getActiveList();
    },
    methods: {
        async getActiveRule() {
            try {
                const { data } = await serverApi.activeRule();
                if (data.code !== 0) throw new Error(data.error);

                this.rule_list = data.data
                    .filter(ele => ele.active_type !== 14)
                    .map(ele => {
                        return { ...ele, schema_name_title: this.rule_schema_name[ele.schema_name] };
                    });
                console.log('this.rule_list', this.rule_list);
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },
        async getActiveList(_params = {}) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                    type: 'task',
                };
                this.loading = true;
                const { data } = await serverApi.activeList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        handDetail(data) {
            this.getUserDetail(data.uid);
            // this.detail = data;
            // this.dialogFormVisible= true
        },
        handleCurrentChange(val) {
            this.getActiveList({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.getActiveList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.getActiveList(this.form);
        },

        async confirm(item) {
            try {
                const params = {
                    uid: item.uid,
                    open_create: !item.open_create,
                };
                const { data } = await serverApi.opencreate(params);
                if (data.code !== 0) throw new Error(data.error);
                this.getUserList();
                this.$message({
                    message: 'Edit success',
                    type: 'success',
                });
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },

        handleAdd() {
            this.info = {};
            this.addFlag = true;
        },
        edit(data) {
            this.info = data;
            this.addFlag = true;
        },
        closeAddModal() {
            this.addFlag = false;
            this.getActiveList();
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
    button {
        width: 100px;
    }
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
